export default [
    {
        text: 'Status',
        value: null
    },
    {
        text: 'Active',
        value: 'active'
    },
    {
        text: 'Suspended',
        value: 'suspended'
    },
    {
        text: 'Prohibited',
        value: 'prohibited'
    },
    {
        text: 'Inactive',
        value: 'inactive'
    },
    {
        text: 'Archived',
        value: 'archived'
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/status/inventoryManagement.js